var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompleteProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 59,
    viewBox: "0 0 55 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0007 27.69C17.3607 27.69 11.1507 21.48 11.1507 13.84C11.0107 10.33 12.3307 6.92 14.8607 4.3C17.5007 1.57 21.1907 0 25.0007 0C32.6407 0 38.8507 6.21 38.8507 13.85C38.8507 21.48 32.6407 27.69 25.0007 27.69ZM25.0007 3.5C22.1307 3.5 19.3607 4.68 17.3807 6.73C15.5207 8.66 14.5507 11.17 14.6507 13.78C14.6507 19.55 19.2907 24.19 25.0007 24.19C30.7107 24.19 35.3507 19.55 35.3507 13.84C35.3507 8.13 30.7107 3.5 25.0007 3.5Z",
    fill: "#B833CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1793 58.6C32.0393 58.6 25.4093 51.98 25.4093 43.83C25.2593 40.09 26.6693 36.45 29.3593 33.65C32.1693 30.73 36.1093 29.06 40.1793 29.06C48.3193 29.06 54.9493 35.68 54.9493 43.83C54.9493 51.98 48.3193 58.6 40.1793 58.6ZM40.1793 32.57C37.0593 32.57 34.0393 33.85 31.8893 36.09C29.8593 38.2 28.8093 40.92 28.9193 43.77C28.9193 50.05 33.9693 55.1 40.1893 55.1C46.4093 55.1 51.4593 50.05 51.4593 43.83C51.4593 37.61 46.3893 32.57 40.1793 32.57Z",
    fill: "#B833CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2604 54.02H5.44043C3.74043 54.02 2.10043 53.23 1.07043 51.91C0.120427 50.69 -0.219573 49.17 0.140427 47.73C2.35043 36.41 12.8104 28.13 25.0004 28.13C28.7204 28.13 32.3004 28.89 35.6504 30.38L34.2304 33.58C31.3304 32.29 28.2304 31.64 25.0104 31.64C14.3204 31.64 5.50043 38.57 3.56043 48.5C3.41043 49.12 3.67043 49.55 3.83043 49.76C4.21043 50.24 4.81043 50.53 5.44043 50.53H30.2604V54.02Z",
    fill: "#B833CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4229 49C35.949 49 35.4842 48.7983 35.1653 48.4125L32.3402 44.9487C31.7934 44.2822 31.921 43.3176 32.6136 42.7915C33.3062 42.2653 34.3086 42.3881 34.8554 43.0545L36.7327 45.3608L45.4723 39.2926C46.1832 38.7927 47.1856 38.9506 47.6959 39.6346C48.2154 40.3186 48.0514 41.2832 47.3405 41.7742L37.3616 48.7106C37.0791 48.9123 36.751 49 36.4229 49Z",
    fill: "#B833CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.94,
    height: 58.6,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteProfile);
export default __webpack_public_path__ + "static/media/complete-profile.13b1a9f7605174d110ec971c984a96e6.svg";
export { ForwardRef as ReactComponent };